import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Trophy, Users } from 'lucide-react';
export function ProAvanzadoSection() {
  const comparisons = [{
    title: 'Alumnos que se aburren y no vuelven',
    sin: 'Repetís siempre los mismos drills porque no tenés más recursos y perdés alumnos sin entender por qué',
    con: 'Sistema completo de fidelización con estrategias concretas para que tus alumnos quieran seguir viniendo mes a mes'
  }, {
    title: 'Querés aumentar tus precios pero no te animás',
    sin: 'No tenés un sistema visible que justifique cobrar más por tus clases y tu tiempo en cancha',
    con: 'Guía completa para profesionalizar tu imagen, estructurar tus servicios y justificar un aumento real de precios con argumentos concretos'
  }, {
    title: 'Querés dar clínicas o workshops rentables',
    sin: 'No sabés por dónde empezar, qué contenido dar ni cómo llenarlo sin gastar en publicidad',
    con: 'Sistema paso a paso para armar clínicas técnicas, workshops tácticos y eventos rentables que se llenan solos con tus alumnos actuales'
  }, {
    title: 'Alumnos estancados que no avanzan hace meses',
    sin: 'No sabés si es técnica, motivación o metodología y no tenés herramientas para diagnosticarlo',
    con: 'Protocolo de diagnóstico técnico-táctico y plan de acción concreto para destrabar el progreso de cualquier alumno en cualquier nivel'
  }, {
    title: 'Querés diferenciarte de todos los entrenadores de tu zona',
    sin: 'Das clases como todos, sin identidad ni metodología propia visible ni argumentos para justificar tu valor',
    con: 'Sistema para crear tu propia metodología de enseñanza con identidad, nombre y estructura profesional que te diferencia del mercado'
  }];
  return <section className="py-12 md:py-20 bg-white" data-id="element-246">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <div className="text-center mb-10 md:mb-16" data-id="element-248">
          <h2 className="text-2xl md:text-4xl font-display text-navy-900 mb-3 md:mb-4 uppercase" data-id="element-249">
            ¿Qué agrega el{' '}
            <span className="text-terracotta" data-id="element-250">Tenis Pro Avanzado™</span>?
          </h2>
          <p className="text-base md:text-xl text-gray-600 font-medium" data-id="element-251">
            El sistema para entrenadores que quieren ir un paso más allá
          </p>
        </div>

        <div className="space-y-4 md:space-y-8 mb-12 md:mb-20" data-id="element-252">
          {comparisons.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gray-50 rounded-2xl p-4 md:p-8 border border-gray-100" data-id="element-253">
              <h3 className="text-base md:text-xl font-bold text-navy-900 mb-4 md:mb-6 text-center" data-id="element-254">
                {item.title}
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-255">
                <div className="bg-red-50/50 p-4 md:p-5 rounded-xl border border-red-100" data-id="element-256">
                  <div className="flex items-center gap-2 text-red-600 font-bold mb-2 uppercase text-xs md:text-sm" data-id="element-257">
                    <X className="w-4 h-4 md:w-5 md:h-5" data-id="element-258" /> SIN:
                  </div>
                  <p className="text-sm md:text-base text-gray-700" data-id="element-259">
                    {item.sin}
                  </p>
                </div>
                <div className="bg-green-50/50 p-4 md:p-5 rounded-xl border border-green-100" data-id="element-260">
                  <div className="flex items-center gap-2 text-green-700 font-bold mb-2 uppercase text-xs md:text-sm" data-id="element-261">
                    <Check className="w-4 h-4 md:w-5 md:h-5" data-id="element-262" /> CON:
                  </div>
                  <p className="text-sm md:text-base text-gray-800 font-medium" data-id="element-263">
                    {item.con}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-6 md:mb-10" data-id="element-264">
          <h3 className="text-xl md:text-2xl font-display text-navy-900 uppercase" data-id="element-265">
            TENIS PRO AVANZADO™ INCLUYE:
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8" data-id="element-266">
          {/* Módulo 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-900 text-white p-6 md:p-8 rounded-3xl relative overflow-hidden border border-navy-700" data-id="element-267">
            <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-268">
              <Trophy className="w-20 h-20 md:w-24 md:h-24" data-id="element-269" />
            </div>
            <div className="w-10 h-10 md:w-12 md:h-12 bg-terracotta text-white font-display text-lg md:text-xl rounded-full flex items-center justify-center mb-4 md:mb-6" data-id="element-270">
              1
            </div>
            <h4 className="text-base md:text-xl font-display mb-1 md:mb-2 text-optic" data-id="element-271">
              Módulo 1 — Tomo 7:
            </h4>
            <h5 className="text-xl md:text-2xl font-bold mb-3 md:mb-4" data-id="element-272">
              Tenis Avanzado y Alto Rendimiento
            </h5>
            <p className="text-sm md:text-base text-gray-300 mb-4 md:mb-6 leading-relaxed" data-id="element-273">
              Periodización para jugadores en competencia, análisis de video y
              scouting básico, preparación específica por superficie, protocolo
              de recuperación post-torneo y cómo llevar a un alumno de club a
              circuito regional.
            </p>
            <p className="text-xs md:text-sm font-bold text-white uppercase tracking-wide" data-id="element-274">
              60 páginas de alto rendimiento real.
            </p>
          </motion.div>

          {/* Módulo 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-terracotta text-white p-6 md:p-8 rounded-3xl relative overflow-hidden" data-id="element-275">
            <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-276">
              <Users className="w-20 h-20 md:w-24 md:h-24" data-id="element-277" />
            </div>
            <div className="w-10 h-10 md:w-12 md:h-12 bg-white text-terracotta font-display text-lg md:text-xl rounded-full flex items-center justify-center mb-4 md:mb-6" data-id="element-278">
              2
            </div>
            <h4 className="text-base md:text-xl font-display mb-1 md:mb-2 text-navy-900" data-id="element-279">
              Módulo 2 — Tomo 8:
            </h4>
            <h5 className="text-xl md:text-2xl font-bold mb-3 md:mb-4" data-id="element-280">
              Mini Tenis y Tenis Infantil
            </h5>
            <p className="text-sm md:text-base text-white/90 mb-4 md:mb-6 leading-relaxed" data-id="element-281">
              El mercado más grande y más abandonado. Metodología ITF Play +
              Tennis adaptada, progresiones por edad de 4 a 12 años, juegos y
              dinámicas para grupos infantiles, cómo hablar con padres y retener
              familias, y plan anual para escuela de tenis infantil.
            </p>
            <p className="text-xs md:text-sm font-bold text-navy-900 uppercase tracking-wide" data-id="element-282">
              60 páginas del nicho más rentable del tenis.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}